import React from "react";

export default function CanvassMap({
    selectedZones,
    toggleZone,
    zoneCoverage
  }) {

    const isSelected = (id) => selectedZones.includes(id);

        const getFill = (id) => {
            const coverage = zoneCoverage[id]?.percentCovered;
        
            // selected zones (blue highlight)
            if (selectedZones.includes(id)) {
                return "rgba(0,150,255,0.35)";
            }
        
            // coverage coloring
            if (coverage === undefined) return "none";
            if (coverage >= 80) return "rgba(0,200,0,0.35)";
            if (coverage >= 40) return "rgba(255,200,0,0.35)";

            return "rgba(255,0,0,0.35)";
        };

        return (
        <svg
            version="1.1"
            id="svg1"
            style={{
                height: "100vh",
                width: "auto",
                display: "block",
                margin: "0 auto"
            }}
            viewBox="0 0 1854 2600"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
        <defs />
        <g
            id="g1"
            style={{ display: "inline" }}>
            <image href="/ogden_map.jpeg" width="1854" height="2600" preserveAspectRatio="none" />
        </g>
        <g id="layer1" />
        <rect
            fill="none"
            stroke="#000"
            strokeWidth="6"
            opacity="1"
            id="rect492"
            width="1862.8848"
            height="2602.2771"
            x="-9.602499"
            y="-9.602499"
            ry="12.978485" />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,1582.8984 h -100 v 100 h 100 z"
        id="zone_1" 
        fill={getFill("zone_1")}
        onClick={() => toggleZone("zone_1")}
        />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,1482.8984 h -100 v 100 h 100 z"
        id="zone_3017"
        fill={getFill("zone_3017")}
        onClick={() => toggleZone("zone_3017")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,1382.8984 h -100 v 100 h 100 z"
        id="zone_3016"
        fill={getFill("zone_3016")}

        onClick={() => toggleZone("zone_3016")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,1282.8984 h -100 v 100 h 100 z"
        id="zone_3015"
        fill={getFill("zone_3015")}

        onClick={() => toggleZone("zone_3015")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,1182.8984 h -100 v 100 h 100 z"
        id="zone_3014"
        fill={getFill("zone_3014")}

        onClick={() => toggleZone("zone_3014")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,1082.8984 h -100 v 100 h 100 z"
        id="zone_3013"
        fill={getFill("zone_3013")}

        onClick={() => toggleZone("zone_3013")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,982.89844 h -100 v 99.99996 h 100 z"
        id="zone_3012"
        fill={getFill("zone_3012")}

        onClick={() => toggleZone("zone_3012")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,882.89844 h -100 v 100 h 100 z"
        id="zone_3011"
        fill={getFill("zone_3011")}

        onClick={() => toggleZone("zone_3011")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,782.89844 h -100 v 100 h 100 z"
        id="zone_3010"
        fill={getFill("zone_3010")}

        onClick={() => toggleZone("zone_3010")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,682.89844 v -100 h -100 v 100 z"
        id="zone_3009"
        fill={getFill("zone_3009")}

        onClick={() => toggleZone("zone_3009")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,682.89844 h -100 v 100 h 100 z"
        id="zone_3008"
        fill={getFill("zone_3008")}

        onClick={() => toggleZone("zone_3008")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,682.89844 h 99.99996 v -100 h -99.99996 z"
        id="zone_3007"
        fill={getFill("zone_3007")}

        onClick={() => toggleZone("zone_3007")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,682.89844 v -100 h -100 v 100 z"
        id="zone_3006"
        fill={getFill("zone_3006")}

        onClick={() => toggleZone("zone_3006")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,782.89844 h 99.99996 v -100 h -99.99996 z"
        id="zone_3005"
        fill={getFill("zone_3005")}

        onClick={() => toggleZone("zone_3005")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,782.89844 v -100 h -100 v 100 z"
        id="zone_3004"
        fill={getFill("zone_3004")}

        onClick={() => toggleZone("zone_3004")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,882.89844 h 99.99996 v -100 h -99.99996 z"
        id="zone_3003"
        fill={getFill("zone_3003")}

        onClick={() => toggleZone("zone_3003")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,882.89844 v -100 h -100 v 100 z"
        id="zone_3002"
        fill={getFill("zone_3002")}

        onClick={() => toggleZone("zone_3002")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,982.89844 h 99.99996 v -100 h -99.99996 z"
        id="zone_3001"
        fill={getFill("zone_3001")}

        onClick={() => toggleZone("zone_3001")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,982.89844 v -100 h -100 v 100 z"
        id="zone_3000"
        fill={getFill("zone_3000")}

        onClick={() => toggleZone("zone_3000")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1082.8984 h 99.99996 v -99.99996 h -99.99996 z"
        id="zone_2999"
        fill={getFill("zone_2999")}

        onClick={() => toggleZone("zone_2999")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1082.8984 v -99.99996 h -100 v 99.99996 z"
        id="zone_2998"
        fill={getFill("zone_2998")}

        onClick={() => toggleZone("zone_2998")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1182.8984 h 99.99996 v -100 h -99.99996 z"
        id="zone_2997"
        fill={getFill("zone_2997")}

        onClick={() => toggleZone("zone_2997")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1182.8984 v -100 h -100 v 100 z"
        id="zone_2996"
        fill={getFill("zone_2996")}

        onClick={() => toggleZone("zone_2996")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1282.8984 h 99.99996 v -100 h -99.99996 z"
        id="zone_2995"
        fill={getFill("zone_2995")}

        onClick={() => toggleZone("zone_2995")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1282.8984 v -100 h -100 v 100 z"
        id="zone_2994"
        fill={getFill("zone_2994")}

        onClick={() => toggleZone("zone_2994")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1382.8984 h 99.99996 v -100 h -99.99996 z"
        id="zone_2993"
        fill={getFill("zone_2993")}

        onClick={() => toggleZone("zone_2993")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1382.8984 v -100 h -100 v 100 z"
        id="zone_2992"
        fill={getFill("zone_2992")}

        onClick={() => toggleZone("zone_2992")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1482.8984 h 99.99996 v -100 h -99.99996 z"
        id="zone_2991"
        fill={getFill("zone_2991")}

        onClick={() => toggleZone("zone_2991")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1482.8984 v -100 h -100 v 100 z"
        id="zone_2990"
        fill={getFill("zone_2990")}

        onClick={() => toggleZone("zone_2990")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1582.8984 h 99.99996 v -100 h -99.99996 z"
        id="zone_2989"
        fill={getFill("zone_2989")}

        onClick={() => toggleZone("zone_2989")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1582.8984 v -100 h -100 v 100 z"
        id="zone_2988"
        fill={getFill("zone_2988")}

        onClick={() => toggleZone("zone_2988")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1682.8984 h 99.99996 v -100 h -99.99996 z"
        id="zone_2987"
        fill={getFill("zone_2987")}

        onClick={() => toggleZone("zone_2987")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1682.8984 v -100 h -100 v 100 z"
        id="zone_2986"
        fill={getFill("zone_2986")}

        onClick={() => toggleZone("zone_2986")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1782.8984 v 100 h 99.99996 v -100 z"
        id="zone_2985"
        fill={getFill("zone_2985")}

        onClick={() => toggleZone("zone_2985")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1782.8984 h 99.99996 v -100 h -99.99996 z"
        id="zone_2984"
        fill={getFill("zone_2984")}

        onClick={() => toggleZone("zone_2984")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,1782.8984 v 100 h 100 v -100 z"
        id="zone_2983"
        fill={getFill("zone_2983")}

        onClick={() => toggleZone("zone_2983")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,1782.8984 h 100 v -100 h -100 z"
        id="zone_2982"
        fill={getFill("zone_2982")}

        onClick={() => toggleZone("zone_2982")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,1782.8984 v 100 h 100 v -100 z"
        id="zone_2981"
        fill={getFill("zone_2981")}

        onClick={() => toggleZone("zone_2981")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,1782.8984 h 100 v -100 h -100 z"
        id="zone_2980"
        fill={getFill("zone_2980")}

        onClick={() => toggleZone("zone_2980")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1782.8984 h -100 v 100 h 100 z"
        id="zone_2979"
        fill={getFill("zone_2979")}

        onClick={() => toggleZone("zone_2979")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1782.8984 v 100 h 100 v -100 z"
        id="zone_2978"
        fill={getFill("zone_2978")}

        onClick={() => toggleZone("zone_2978")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1682.8984 h -100 v 100 h 100 z"
        id="zone_2977"
        fill={getFill("zone_2977")}

        onClick={() => toggleZone("zone_2977")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1682.8984 v 100 h 100 v -100 z"
        id="zone_2976"
        fill={getFill("zone_2976")}

        onClick={() => toggleZone("zone_2976")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1582.8984 h -100 v 100 h 100 z"
        id="zone_2975"
        fill={getFill("zone_2975")}

        onClick={() => toggleZone("zone_2975")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1582.8984 v 100 h 100 v -100 z"
        id="zone_2974"
        fill={getFill("zone_2974")}

        onClick={() => toggleZone("zone_2974")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1482.8984 h -100 v 100 h 100 z"
        id="zone_2973"
        fill={getFill("zone_2973")}

        onClick={() => toggleZone("zone_2973")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1482.8984 v 100 h 100 v -100 z"
        id="zone_2972"
        fill={getFill("zone_2972")}

        onClick={() => toggleZone("zone_2972")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1382.8984 h -100 v 100 h 100 z"
        id="zone_2971"
        fill={getFill("zone_2971")}

        onClick={() => toggleZone("zone_2971")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1382.8984 v 100 h 100 v -100 z"
        id="zone_2970"
        fill={getFill("zone_2970")}

        onClick={() => toggleZone("zone_2970")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1282.8984 h -100 v 100 h 100 z"
        id="zone_2969"
        fill={getFill("zone_2969")}

        onClick={() => toggleZone("zone_2969")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1282.8984 v 100 h 100 v -100 z"
        id="zone_2968"
        fill={getFill("zone_2968")}

        onClick={() => toggleZone("zone_2968")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1182.8984 h -100 v 100 h 100 z"
        id="zone_2967"
        fill={getFill("zone_2967")}

        onClick={() => toggleZone("zone_2967")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1182.8984 v 100 h 100 v -100 z"
        id="zone_2966"
        fill={getFill("zone_2966")}

        onClick={() => toggleZone("zone_2966")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1082.8984 h -100 v 100 h 100 z"
        id="zone_2965"
        fill={getFill("zone_2965")}

        onClick={() => toggleZone("zone_2965")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1082.8984 v 100 h 100 v -100 z"
        id="zone_2964"
        fill={getFill("zone_2964")}

        onClick={() => toggleZone("zone_2964")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,982.89844 h -100 v 99.99996 h 100 z"
        id="zone_2963"
        fill={getFill("zone_2963")}

        onClick={() => toggleZone("zone_2963")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,982.89844 v 99.99996 h 100 v -99.99996 z"
        id="zone_2962"
        fill={getFill("zone_2962")}

        onClick={() => toggleZone("zone_2962")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,882.89844 h -100 v 100 h 100 z"
        id="zone_2961"
        fill={getFill("zone_2961")}

        onClick={() => toggleZone("zone_2961")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,882.89844 v 100 h 100 v -100 z"
        id="zone_2960"
        fill={getFill("zone_2960")}

        onClick={() => toggleZone("zone_2960")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,782.89844 h -100 v 100 h 100 z"
        id="zone_2959"
        fill={getFill("zone_2959")}

        onClick={() => toggleZone("zone_2959")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,782.89844 v 100 h 100 v -100 z"
        id="zone_2958"
        fill={getFill("zone_2958")}

        onClick={() => toggleZone("zone_2958")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,682.89844 h -100 v 100 h 100 z"
        id="zone_2957"
        fill={getFill("zone_2957")}

        onClick={() => toggleZone("zone_2957")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,682.89844 v 100 h 100 v -100 z"
        id="zone_2956"
        fill={getFill("zone_2956")}

        onClick={() => toggleZone("zone_2956")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,582.89844 h -100 v 100 h 100 z"
        id="zone_2955"
        fill={getFill("zone_2955")}

        onClick={() => toggleZone("zone_2955")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,582.89844 v 100 h 100 v -100 z"
        id="zone_2954"
        fill={getFill("zone_2954")}

        onClick={() => toggleZone("zone_2954")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,482.89844 v -100 h -100 v 100 z"
        id="zone_2953"
        fill={getFill("zone_2953")}

        onClick={() => toggleZone("zone_2953")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,482.89844 h -100 v 100 h 100 z"
        id="zone_2952"
        fill={getFill("zone_2952")}

        onClick={() => toggleZone("zone_2952")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,482.89844 v -100 h -100 v 100 z"
        id="zone_2951"
        fill={getFill("zone_2951")}

        onClick={() => toggleZone("zone_2951")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,482.89844 h -100 v 100 h 100 z"
        id="zone_2950"
        fill={getFill("zone_2950")}

        onClick={() => toggleZone("zone_2950")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,482.89844 v -100 h -100 v 100 z"
        id="zone_2949"
        fill={getFill("zone_2949")}

        onClick={() => toggleZone("zone_2949")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,482.89844 h -100 v 100 h 100 z"
        id="zone_2948"
        fill={getFill("zone_2948")}

        onClick={() => toggleZone("zone_2948")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,482.89844 v -100 h -100 v 100 z"
        id="zone_2947"
        fill={getFill("zone_2947")}

        onClick={() => toggleZone("zone_2947")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,482.89844 h -100 v 100 h 100 z"
        id="zone_2946"
        fill={getFill("zone_2946")}

        onClick={() => toggleZone("zone_2946")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1082.8984,482.89844 v -100 h -99.99996 v 100 z"
        id="zone_2945"
        fill={getFill("zone_2945")}

        onClick={() => toggleZone("zone_2945")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1082.8984,482.89844 h -99.99996 v 100 h 99.99996 z"
        id="zone_2944"
        fill={getFill("zone_2944")}

        onClick={() => toggleZone("zone_2944")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,482.89844 h 100 v -100 h -100 z"
        id="zone_2943"
        fill={getFill("zone_2943")}

        onClick={() => toggleZone("zone_2943")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,482.89844 v -100 h -100 v 100 z"
        id="zone_2942"
        fill={getFill("zone_2942")}

        onClick={() => toggleZone("zone_2942")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,582.89844 h 100 v -100 h -100 z"
        id="zone_2941"
        fill={getFill("zone_2941")}

        onClick={() => toggleZone("zone_2941")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,582.89844 v -100 h -100 v 100 z"
        id="zone_2940"
        fill={getFill("zone_2940")}

        onClick={() => toggleZone("zone_2940")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,682.89844 h 100 v -100 h -100 z"
        id="zone_2939"
        fill={getFill("zone_2939")}

        onClick={() => toggleZone("zone_2939")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,682.89844 v -100 h -100 v 100 z"
        id="zone_2938"
        fill={getFill("zone_2938")}

        onClick={() => toggleZone("zone_2938")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,782.89844 h 100 v -100 h -100 z"
        id="zone_2937"
        fill={getFill("zone_2937")}

        onClick={() => toggleZone("zone_2937")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,782.89844 v -100 h -100 v 100 z"
        id="zone_2936"
        fill={getFill("zone_2936")}

        onClick={() => toggleZone("zone_2936")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,882.89844 h 100 v -100 h -100 z"
        id="zone_2935"
        fill={getFill("zone_2935")}

        onClick={() => toggleZone("zone_2935")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,882.89844 v -100 h -100 v 100 z"
        id="zone_2934"
        fill={getFill("zone_2934")}

        onClick={() => toggleZone("zone_2934")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,982.89844 h 100 v -100 h -100 z"
        id="zone_2933"
        fill={getFill("zone_2933")}

        onClick={() => toggleZone("zone_2933")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,982.89844 v -100 h -100 v 100 z"
        id="zone_2932"
        fill={getFill("zone_2932")}

        onClick={() => toggleZone("zone_2932")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1082.8984 h 100 v -99.99996 h -100 z"
        id="zone_2931"
        fill={getFill("zone_2931")}

        onClick={() => toggleZone("zone_2931")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1082.8984 v -99.99996 h -100 v 99.99996 z"
        id="zone_2930"
        fill={getFill("zone_2930")}

        onClick={() => toggleZone("zone_2930")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1182.8984 h 100 v -100 h -100 z"
        id="zone_2929"
        fill={getFill("zone_2929")}

        onClick={() => toggleZone("zone_2929")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1182.8984 v -100 h -100 v 100 z"
        id="zone_2928"
        fill={getFill("zone_2928")}

        onClick={() => toggleZone("zone_2928")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1282.8984 h 100 v -100 h -100 z"
        id="zone_2927"
        fill={getFill("zone_2927")}

        onClick={() => toggleZone("zone_2927")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1282.8984 v -100 h -100 v 100 z"
        id="zone_2926"
        fill={getFill("zone_2926")}

        onClick={() => toggleZone("zone_2926")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1382.8984 h 100 v -100 h -100 z"
        id="zone_2925"
        fill={getFill("zone_2925")}

        onClick={() => toggleZone("zone_2925")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1382.8984 v -100 h -100 v 100 z"
        id="zone_2924"
        fill={getFill("zone_2924")}

        onClick={() => toggleZone("zone_2924")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1482.8984 h 100 v -100 h -100 z"
        id="zone_2923"
        fill={getFill("zone_2923")}

        onClick={() => toggleZone("zone_2923")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1482.8984 v -100 h -100 v 100 z"
        id="zone_2922"
        fill={getFill("zone_2922")}

        onClick={() => toggleZone("zone_2922")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1582.8984 h 100 v -100 h -100 z"
        id="zone_2921"
        fill={getFill("zone_2921")}

        onClick={() => toggleZone("zone_2921")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1582.8984 v -100 h -100 v 100 z"
        id="zone_2920"
        fill={getFill("zone_2920")}

        onClick={() => toggleZone("zone_2920")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1682.8984 h 100 v -100 h -100 z"
        id="zone_2919"
        fill={getFill("zone_2919")}

        onClick={() => toggleZone("zone_2919")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1682.8984 v -100 h -100 v 100 z"
        id="zone_2918"
        fill={getFill("zone_2918")}

        onClick={() => toggleZone("zone_2918")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1782.8984 h 100 v -100 h -100 z"
        id="zone_2917"
        fill={getFill("zone_2917")}

        onClick={() => toggleZone("zone_2917")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1782.8984 v -100 h -100 v 100 z"
        id="zone_2916"
        fill={getFill("zone_2916")}

        onClick={() => toggleZone("zone_2916")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1882.8984 h 100 v -100 h -100 z"
        id="zone_2915"
        fill={getFill("zone_2915")}

        onClick={() => toggleZone("zone_2915")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1882.8984 v -100 h -100 v 100 z"
        id="zone_2914"
        fill={getFill("zone_2914")}

        onClick={() => toggleZone("zone_2914")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1982.8984 v 100 h 100 v -100 z"
        id="zone_2913"
        fill={getFill("zone_2913")}

        onClick={() => toggleZone("zone_2913")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,1982.8984 h 100 v -100 h -100 z"
        id="zone_2912"
        fill={getFill("zone_2912")}

        onClick={() => toggleZone("zone_2912")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1082.8984,1982.8984 v 100 h 100 v -100 z"
        id="zone_2911"
        fill={getFill("zone_2911")}

        onClick={() => toggleZone("zone_2911")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1082.8984,1982.8984 h 100 v -100 h -100 z"
        id="zone_2910"
        fill={getFill("zone_2910")}

        onClick={() => toggleZone("zone_2910")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1982.8984 v 100 h 99.99996 v -100 z"
        id="zone_2909"
        fill={getFill("zone_2909")}

        onClick={() => toggleZone("zone_2909")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,1982.8984 h 99.99996 v -100 h -99.99996 z"
        id="zone_2908"
        fill={getFill("zone_2908")}

        onClick={() => toggleZone("zone_2908")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,1982.8984 v 100 h 100 v -100 z"
        id="zone_2907"
        fill={getFill("zone_2907")}

        onClick={() => toggleZone("zone_2907")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,1982.8984 h 100 v -100 h -100 z"
        id="zone_2906"
        fill={getFill("zone_2906")}

        onClick={() => toggleZone("zone_2906")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,1982.8984 v 100 h 100 v -100 z"
        id="zone_2905"
        fill={getFill("zone_2905")}

        onClick={() => toggleZone("zone_2905")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,1982.8984 h 100 v -100 h -100 z"
        id="zone_2904"
        fill={getFill("zone_2904")}

        onClick={() => toggleZone("zone_2904")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1982.8984 v 100 h 100 v -100 z"
        id="zone_2903"
        fill={getFill("zone_2903")}

        onClick={() => toggleZone("zone_2903")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,1982.8984 h 100 v -100 h -100 z"
        id="zone_2902"
        fill={getFill("zone_2902")}

        onClick={() => toggleZone("zone_2902")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 582.89844,1982.8984 v 100 h 100 v -100 z"
        id="zone_2901"
        fill={getFill("zone_2901")}

        onClick={() => toggleZone("zone_2901")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 582.89844,1982.8984 h 100 v -100 h -100 z"
        id="zone_2900"
        fill={getFill("zone_2900")}

        onClick={() => toggleZone("zone_2900")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1982.8984 h -100 v 100 h 100 z"
        id="zone_2899"
        fill={getFill("zone_2899")}

        onClick={() => toggleZone("zone_2899")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1982.8984 v 100 h 100 v -100 z"
        id="zone_2898"
        fill={getFill("zone_2898")}

        onClick={() => toggleZone("zone_2898")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1882.8984 h -100 v 100 h 100 z"
        id="zone_2897"
        fill={getFill("zone_2897")}

        onClick={() => toggleZone("zone_2897")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1882.8984 v 100 h 100 v -100 z"
        id="zone_2896"
        fill={getFill("zone_2896")}

        onClick={() => toggleZone("zone_2896")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1782.8984 h -100 v 100 h 100 z"
        id="zone_2895"
        fill={getFill("zone_2895")}

        onClick={() => toggleZone("zone_2895")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1782.8984 v 100 h 100 v -100 z"
        id="zone_2894"
        fill={getFill("zone_2894")}

        onClick={() => toggleZone("zone_2894")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1682.8984 h -100 v 100 h 100 z"
        id="zone_2893"
        fill={getFill("zone_2893")}

        onClick={() => toggleZone("zone_2893")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1682.8984 v 100 h 100 v -100 z"
        id="zone_2892"
        fill={getFill("zone_2892")}

        onClick={() => toggleZone("zone_2892")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1582.8984 h -100 v 100 h 100 z"
        id="zone_2891"
        fill={getFill("zone_2891")}

        onClick={() => toggleZone("zone_2891")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1582.8984 v 100 h 100 v -100 z"
        id="zone_2890"
        fill={getFill("zone_2890")}

        onClick={() => toggleZone("zone_2890")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1482.8984 h -100 v 100 h 100 z"
        id="zone_2889"
        fill={getFill("zone_2889")}

        onClick={() => toggleZone("zone_2889")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1482.8984 v 100 h 100 v -100 z"
        id="zone_2888"
        fill={getFill("zone_2888")}

        onClick={() => toggleZone("zone_2888")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1382.8984 h -100 v 100 h 100 z"
        id="zone_2887"
        fill={getFill("zone_2887")}

        onClick={() => toggleZone("zone_2887")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1382.8984 v 100 h 100 v -100 z"
        id="zone_2886"
        fill={getFill("zone_2886")}

        onClick={() => toggleZone("zone_2886")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1282.8984 h -100 v 100 h 100 z"
        id="zone_2885"
        fill={getFill("zone_2885")}

        onClick={() => toggleZone("zone_2885")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1282.8984 v 100 h 100 v -100 z"
        id="zone_2884"
        fill={getFill("zone_2884")}

        onClick={() => toggleZone("zone_2884")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1182.8984 h -100 v 100 h 100 z"
        id="zone_2883"
        fill={getFill("zone_2883")}

        onClick={() => toggleZone("zone_2883")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1182.8984 v 100 h 100 v -100 z"
        id="zone_2882"
        fill={getFill("zone_2882")}

        onClick={() => toggleZone("zone_2882")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1082.8984 h -100 v 100 h 100 z"
        id="zone_2881"
        fill={getFill("zone_2881")}

        onClick={() => toggleZone("zone_2881")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,1082.8984 v 100 h 100 v -100 z"
        id="zone_2880"
        fill={getFill("zone_2880")}

        onClick={() => toggleZone("zone_2880")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,982.89844 h -100 v 99.99996 h 100 z"
        id="zone_2879"
        fill={getFill("zone_2879")}

        onClick={() => toggleZone("zone_2879")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,982.89844 v 99.99996 h 100 v -99.99996 z"
        id="zone_2878"
        fill={getFill("zone_2878")}

        onClick={() => toggleZone("zone_2878")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,882.89844 h -100 v 100 h 100 z"
        id="zone_2877"
        fill={getFill("zone_2877")}

        onClick={() => toggleZone("zone_2877")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,882.89844 v 100 h 100 v -100 z"
        id="zone_2876"
        fill={getFill("zone_2876")}

        onClick={() => toggleZone("zone_2876")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,782.89844 h -100 v 100 h 100 z"
        id="zone_2875"
        fill={getFill("zone_2875")}

        onClick={() => toggleZone("zone_2875")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,782.89844 v 100 h 100 v -100 z"
        id="zone_2874"
        fill={getFill("zone_2874")}

        onClick={() => toggleZone("zone_2874")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,682.89844 h -100 v 100 h 100 z"
        id="zone_2873"
        fill={getFill("zone_2873")}

        onClick={() => toggleZone("zone_2873")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,682.89844 v 100 h 100 v -100 z"
        id="zone_2872"
        fill={getFill("zone_2872")}

        onClick={() => toggleZone("zone_2872")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,582.89844 h -100 v 100 h 100 z"
        id="zone_2871"
        fill={getFill("zone_2871")}

        onClick={() => toggleZone("zone_2871")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,582.89844 v 100 h 100 v -100 z"
        id="zone_2870"
        fill={getFill("zone_2870")}

        onClick={() => toggleZone("zone_2870")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,482.89844 h -100 v 100 h 100 z"
        id="zone_2869"
        fill={getFill("zone_2869")}

        onClick={() => toggleZone("zone_2869")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,482.89844 v 100 h 100 v -100 z"
        id="zone_2868"
        fill={getFill("zone_2868")}

        onClick={() => toggleZone("zone_2868")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,382.89844 h -100 v 100 h 100 z"
        id="zone_2867"
        fill={getFill("zone_2867")}

        onClick={() => toggleZone("zone_2867")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,382.89844 v 100 h 100 v -100 z"
        id="zone_2866"
        fill={getFill("zone_2866")}

        onClick={() => toggleZone("zone_2866")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,282.89844 v -100 h -100 v 100 z"
        id="zone_2865"
        fill={getFill("zone_2865")}

        onClick={() => toggleZone("zone_2865")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,282.89844 h -100 v 100 h 100 z"
        id="zone_2864"
        fill={getFill("zone_2864")}

        onClick={() => toggleZone("zone_2864")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 582.89844,282.89844 v -100 h -100 v 100 z"
        id="zone_2863"
        fill={getFill("zone_2863")}

        onClick={() => toggleZone("zone_2863")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 582.89844,282.89844 h -100 v 100 h 100 z"
        id="zone_2862"
        fill={getFill("zone_2862")}

        onClick={() => toggleZone("zone_2862")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,282.89844 v -100 h -100 v 100 z"
        id="zone_2861"
        fill={getFill("zone_2861")}

        onClick={() => toggleZone("zone_2861")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,282.89844 h -100 v 100 h 100 z"
        id="zone_2860"
        fill={getFill("zone_2860")}

        onClick={() => toggleZone("zone_2860")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,282.89844 v -100 h -100 v 100 z"
        id="zone_2859"
        fill={getFill("zone_2859")}

        onClick={() => toggleZone("zone_2859")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,282.89844 h -100 v 100 h 100 z"
        id="zone_2858"
        fill={getFill("zone_2858")}

        onClick={() => toggleZone("zone_2858")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,282.89844 v -100 h -100 v 100 z"
        id="zone_2857"
        fill={getFill("zone_2857")}

        onClick={() => toggleZone("zone_2857")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,282.89844 h -100 v 100 h 100 z"
        id="zone_2856"
        fill={getFill("zone_2856")}

        onClick={() => toggleZone("zone_2856")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,282.89844 v -100 h -100 v 100 z"
        id="zone_2855"
        fill={getFill("zone_2855")}

        onClick={() => toggleZone("zone_2855")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,282.89844 h -100 v 100 h 100 z"
        id="zone_2854"
        fill={getFill("zone_2854")}

        onClick={() => toggleZone("zone_2854")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1082.8984,282.89844 v -100 h -99.99996 v 100 z"
        id="zone_2853"
        fill={getFill("zone_2853")}

        onClick={() => toggleZone("zone_2853")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1082.8984,282.89844 h -99.99996 v 100 h 99.99996 z"
        id="zone_2852"
        fill={getFill("zone_2852")}

        onClick={() => toggleZone("zone_2852")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,282.89844 v -100 h -100 v 100 z"
        id="zone_2851"
        fill={getFill("zone_2851")}

        onClick={() => toggleZone("zone_2851")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,282.89844 h -100 v 100 h 100 z"
        id="zone_2850"
        fill={getFill("zone_2850")}

        onClick={() => toggleZone("zone_2850")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1282.8984,282.89844 v -100 h -100 v 100 z"
        id="zone_2849"
        fill={getFill("zone_2849")}

        onClick={() => toggleZone("zone_2849")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1282.8984,282.89844 h -100 v 100 h 100 z"
        id="zone_2848"
        fill={getFill("zone_2848")}

        onClick={() => toggleZone("zone_2848")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,282.89844 h 100 v -100 h -100 z"
        id="zone_2847"
        fill={getFill("zone_2847")}

        onClick={() => toggleZone("zone_2847")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,282.89844 v -100 h -100 v 100 z"
        id="zone_2846"
        fill={getFill("zone_2846")}

        onClick={() => toggleZone("zone_2846")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,382.89844 h 100 v -100 h -100 z"
        id="zone_2845"
        fill={getFill("zone_2845")}

        onClick={() => toggleZone("zone_2845")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,382.89844 v -100 h -100 v 100 z"
        id="zone_2844"
        fill={getFill("zone_2844")}

        onClick={() => toggleZone("zone_2844")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,482.89844 h 100 v -100 h -100 z"
        id="zone_2843"
        fill={getFill("zone_2843")}

        onClick={() => toggleZone("zone_2843")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,482.89844 v -100 h -100 v 100 z"
        id="zone_2842"
        fill={getFill("zone_2842")}

        onClick={() => toggleZone("zone_2842")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,582.89844 h 100 v -100 h -100 z"
        id="zone_2841"
        fill={getFill("zone_2841")}

        onClick={() => toggleZone("zone_2841")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,582.89844 v -100 h -100 v 100 z"
        id="zone_2840"
        fill={getFill("zone_2840")}

        onClick={() => toggleZone("zone_2840")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,682.89844 h 100 v -100 h -100 z"
        id="zone_2839"
        fill={getFill("zone_2839")}

        onClick={() => toggleZone("zone_2839")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,682.89844 v -100 h -100 v 100 z"
        id="zone_2838"
        fill={getFill("zone_2838")}

        onClick={() => toggleZone("zone_2838")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,782.89844 h 100 v -100 h -100 z"
        id="zone_2837"
        fill={getFill("zone_2837")}

        onClick={() => toggleZone("zone_2837")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,782.89844 v -100 h -100 v 100 z"
        id="zone_2836"
        fill={getFill("zone_2836")}

        onClick={() => toggleZone("zone_2836")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,882.89844 h 100 v -100 h -100 z"
        id="zone_2835"
        fill={getFill("zone_2835")}

        onClick={() => toggleZone("zone_2835")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,882.89844 v -100 h -100 v 100 z"
        id="zone_2834"
        fill={getFill("zone_2834")}

        onClick={() => toggleZone("zone_2834")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,982.89844 h 100 v -100 h -100 z"
        id="zone_2833"
        fill={getFill("zone_2833")}

        onClick={() => toggleZone("zone_2833")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,982.89844 v -100 h -100 v 100 z"
        id="zone_2832"
        fill={getFill("zone_2832")}

        onClick={() => toggleZone("zone_2832")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1082.8984 h 100 v -99.99996 h -100 z"
        id="zone_2831"
        fill={getFill("zone_2831")}

        onClick={() => toggleZone("zone_2831")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1082.8984 v -99.99996 h -100 v 99.99996 z"
        id="zone_2830"
        fill={getFill("zone_2830")}

        onClick={() => toggleZone("zone_2830")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1182.8984 h 100 v -100 h -100 z"
        id="zone_2829"
        fill={getFill("zone_2829")}

        onClick={() => toggleZone("zone_2829")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1182.8984 v -100 h -100 v 100 z"
        id="zone_2828"
        fill={getFill("zone_2828")}

        onClick={() => toggleZone("zone_2828")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1282.8984 h 100 v -100 h -100 z"
        id="zone_2827"
        fill={getFill("zone_2827")}

        onClick={() => toggleZone("zone_2827")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1282.8984 v -100 h -100 v 100 z"
        id="zone_2826"
        fill={getFill("zone_2826")}

        onClick={() => toggleZone("zone_2826")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1382.8984 h 100 v -100 h -100 z"
        id="zone_2825"
        fill={getFill("zone_2825")}

        onClick={() => toggleZone("zone_2825")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1382.8984 v -100 h -100 v 100 z"
        id="zone_2824"
        fill={getFill("zone_2824")}

        onClick={() => toggleZone("zone_2824")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1482.8984 h 100 v -100 h -100 z"
        id="zone_2823"
        fill={getFill("zone_2823")}

        onClick={() => toggleZone("zone_2823")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1482.8984 v -100 h -100 v 100 z"
        id="zone_2822"
        fill={getFill("zone_2822")}

        onClick={() => toggleZone("zone_2822")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1582.8984 h 100 v -100 h -100 z"
        id="zone_2821"
        fill={getFill("zone_2821")}

        onClick={() => toggleZone("zone_2821")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1582.8984 v -100 h -100 v 100 z"
        id="zone_2820"
        fill={getFill("zone_2820")}

        onClick={() => toggleZone("zone_2820")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1682.8984 h 100 v -100 h -100 z"
        id="zone_2819"
        fill={getFill("zone_2819")}

        onClick={() => toggleZone("zone_2819")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1682.8984 v -100 h -100 v 100 z"
        id="zone_2818"
        fill={getFill("zone_2818")}

        onClick={() => toggleZone("zone_2818")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1782.8984 h 100 v -100 h -100 z"
        id="zone_2817"
        fill={getFill("zone_2817")}

        onClick={() => toggleZone("zone_2817")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1782.8984 v -100 h -100 v 100 z"
        id="zone_2816"
        fill={getFill("zone_2816")}

        onClick={() => toggleZone("zone_2816")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1882.8984 h 100 v -100 h -100 z"
        id="zone_2815"
        fill={getFill("zone_2815")}

        onClick={() => toggleZone("zone_2815")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1882.8984 v -100 h -100 v 100 z"
        id="zone_2814"
        fill={getFill("zone_2814")}

        onClick={() => toggleZone("zone_2814")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1982.8984 h 100 v -100 h -100 z"
        id="zone_2813"
        fill={getFill("zone_2813")}

        onClick={() => toggleZone("zone_2813")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,1982.8984 v -100 h -100 v 100 z"
        id="zone_2812"
        fill={getFill("zone_2812")}

        onClick={() => toggleZone("zone_2812")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,2082.8984 h 100 v -100 h -100 z"
        id="zone_2811"
        fill={getFill("zone_2811")}

        onClick={() => toggleZone("zone_2811")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,2082.8984 v -100 h -100 v 100 z"
        id="zone_2810"
        fill={getFill("zone_2810")}

        onClick={() => toggleZone("zone_2810")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,2182.8984 v 100 h 100 v -100 z"
        id="zone_2809"
        fill={getFill("zone_2809")}

        onClick={() => toggleZone("zone_2809")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,2182.8984 h 100 v -100 h -100 z"
        id="zone_2808"
        fill={getFill("zone_2808")}

        onClick={() => toggleZone("zone_2808")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1282.8984,2182.8984 v 100 h 100 v -100 z"
        id="zone_2807"
        fill={getFill("zone_2807")}

        onClick={() => toggleZone("zone_2807")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1282.8984,2182.8984 h 100 v -100 h -100 z"
        id="zone_2806"
        fill={getFill("zone_2806")}

        onClick={() => toggleZone("zone_2806")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,2182.8984 v 100 h 100 v -100 z"
        id="zone_2805"
        fill={getFill("zone_2805")}

        onClick={() => toggleZone("zone_2805")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,2182.8984 h 100 v -100 h -100 z"
        id="zone_2804"
        fill={getFill("zone_2804")}

        onClick={() => toggleZone("zone_2804")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1082.8984,2182.8984 v 100 h 100 v -100 z"
        id="zone_2803"
        fill={getFill("zone_2803")}

        onClick={() => toggleZone("zone_2803")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1082.8984,2182.8984 h 100 v -100 h -100 z"
        id="zone_2802"
        fill={getFill("zone_2802")}

        onClick={() => toggleZone("zone_2802")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,2182.8984 v 100 h 99.99996 v -100 z"
        id="zone_2801"
        fill={getFill("zone_2801")}

        onClick={() => toggleZone("zone_2801")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,2182.8984 h 99.99996 v -100 h -99.99996 z"
        id="zone_2800"
        fill={getFill("zone_2800")}

        onClick={() => toggleZone("zone_2800")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,2182.8984 v 100 h 100 v -100 z"
        id="zone_2799"
        fill={getFill("zone_2799")}

        onClick={() => toggleZone("zone_2799")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,2182.8984 h 100 v -100 h -100 z"
        id="zone_2798"
        fill={getFill("zone_2798")}

        onClick={() => toggleZone("zone_2798")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,2182.8984 v 100 h 100 v -100 z"
        id="zone_2797"
        fill={getFill("zone_2797")}

        onClick={() => toggleZone("zone_2797")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,2182.8984 h 100 v -100 h -100 z"
        id="zone_2796"
        fill={getFill("zone_2796")}

        onClick={() => toggleZone("zone_2796")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,2182.8984 v 100 h 100 v -100 z"
        id="zone_2795"
        fill={getFill("zone_2795")}

        onClick={() => toggleZone("zone_2795")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,2182.8984 h 100 v -100 h -100 z"
        id="zone_2794"
        fill={getFill("zone_2794")}

        onClick={() => toggleZone("zone_2794")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 582.89844,2182.8984 v 100 h 100 v -100 z"
        id="zone_2793"
        fill={getFill("zone_2793")}

        onClick={() => toggleZone("zone_2793")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 582.89844,2182.8984 h 100 v -100 h -100 z"
        id="zone_2792"
        fill={getFill("zone_2792")}

        onClick={() => toggleZone("zone_2792")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,2182.8984 v 100 h 100 v -100 z"
        id="zone_2791"
        fill={getFill("zone_2791")}

        onClick={() => toggleZone("zone_2791")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,2182.8984 h 100 v -100 h -100 z"
        id="zone_2790"
        fill={getFill("zone_2790")}

        onClick={() => toggleZone("zone_2790")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 382.89844,2182.8984 v 100 h 100 v -100 z"
        id="zone_2789"
        fill={getFill("zone_2789")}

        onClick={() => toggleZone("zone_2789")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 382.89844,2182.8984 h 100 v -100 h -100 z"
        id="zone_2788"
        fill={getFill("zone_2788")}

        onClick={() => toggleZone("zone_2788")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,2182.8984 h -100 v 100 h 100 z"
        id="zone_2787"
        fill={getFill("zone_2787")}

        onClick={() => toggleZone("zone_2787")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,2182.8984 v 100 h 100 v -100 z"
        id="zone_2786"
        fill={getFill("zone_2786")}

        onClick={() => toggleZone("zone_2786")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,2082.8984 h -100 v 100 h 100 z"
        id="zone_2785"
        fill={getFill("zone_2785")}

        onClick={() => toggleZone("zone_2785")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,2082.8984 v 100 h 100 v -100 z"
        id="zone_2784"
        fill={getFill("zone_2784")}

        onClick={() => toggleZone("zone_2784")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1982.8984 h -100 v 100 h 100 z"
        id="zone_2783"
        fill={getFill("zone_2783")}

        onClick={() => toggleZone("zone_2783")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1982.8984 v 100 h 100 v -100 z"
        id="zone_2782"
        fill={getFill("zone_2782")}

        onClick={() => toggleZone("zone_2782")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1882.8984 h -100 v 100 h 100 z"
        id="zone_2781"
        fill={getFill("zone_2781")}

        onClick={() => toggleZone("zone_2781")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1882.8984 v 100 h 100 v -100 z"
        id="zone_2780"
        fill={getFill("zone_2780")}

        onClick={() => toggleZone("zone_2780")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1782.8984 h -100 v 100 h 100 z"
        id="zone_2779"
        fill={getFill("zone_2779")}

        onClick={() => toggleZone("zone_2779")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1782.8984 v 100 h 100 v -100 z"
        id="zone_2778"
        fill={getFill("zone_2778")}

        onClick={() => toggleZone("zone_2778")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1682.8984 h -100 v 100 h 100 z"
        id="zone_2777"
        fill={getFill("zone_2777")}

        onClick={() => toggleZone("zone_2777")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1682.8984 v 100 h 100 v -100 z"
        id="zone_2776"
        fill={getFill("zone_2776")}

        onClick={() => toggleZone("zone_2776")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1582.8984 h -100 v 100 h 100 z"
        id="zone_2775"
        fill={getFill("zone_2775")}

        onClick={() => toggleZone("zone_2775")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1582.8984 v 100 h 100 v -100 z"
        id="zone_2774"
        fill={getFill("zone_2774")}

        onClick={() => toggleZone("zone_2774")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1482.8984 h -100 v 100 h 100 z"
        id="zone_2773"
        fill={getFill("zone_2773")}

        onClick={() => toggleZone("zone_2773")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1482.8984 v 100 h 100 v -100 z"
        id="zone_2772"
        fill={getFill("zone_2772")}

        onClick={() => toggleZone("zone_2772")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1382.8984 h -100 v 100 h 100 z"
        id="zone_2771"
        fill={getFill("zone_2771")}

        onClick={() => toggleZone("zone_2771")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1382.8984 v 100 h 100 v -100 z"
        id="zone_2770"
        fill={getFill("zone_2770")}

        onClick={() => toggleZone("zone_2770")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1282.8984 h -100 v 100 h 100 z"
        id="zone_2769"
        fill={getFill("zone_2769")}

        onClick={() => toggleZone("zone_2769")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1282.8984 v 100 h 100 v -100 z"
        id="zone_2768"
        fill={getFill("zone_2768")}

        onClick={() => toggleZone("zone_2768")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1182.8984 h -100 v 100 h 100 z"
        id="zone_2767"
        fill={getFill("zone_2767")}

        onClick={() => toggleZone("zone_2767")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1182.8984 v 100 h 100 v -100 z"
        id="zone_2766"
        fill={getFill("zone_2766")}

        onClick={() => toggleZone("zone_2766")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1082.8984 h -100 v 100 h 100 z"
        id="zone_2765"
        fill={getFill("zone_2765")}

        onClick={() => toggleZone("zone_2765")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,1082.8984 v 100 h 100 v -100 z"
        id="zone_2764"
        fill={getFill("zone_2764")}

        onClick={() => toggleZone("zone_2764")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,982.89844 h -100 v 99.99996 h 100 z"
        id="zone_2763"
        fill={getFill("zone_2763")}

        onClick={() => toggleZone("zone_2763")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,982.89844 v 99.99996 h 100 v -99.99996 z"
        id="zone_2762"
        fill={getFill("zone_2762")}

        onClick={() => toggleZone("zone_2762")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,882.89844 h -100 v 100 h 100 z"
        id="zone_2761"
        fill={getFill("zone_2761")}

        onClick={() => toggleZone("zone_2761")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,882.89844 v 100 h 100 v -100 z"
        id="zone_2760"
        fill={getFill("zone_2760")}

        onClick={() => toggleZone("zone_2760")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,782.89844 h -100 v 100 h 100 z"
        id="zone_2759"
        fill={getFill("zone_2759")}

        onClick={() => toggleZone("zone_2759")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,782.89844 v 100 h 100 v -100 z"
        id="zone_2758"
        fill={getFill("zone_2758")}

        onClick={() => toggleZone("zone_2758")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,682.89844 h -100 v 100 h 100 z"
        id="zone_2757"
        fill={getFill("zone_2757")}

        onClick={() => toggleZone("zone_2757")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,682.89844 v 100 h 100 v -100 z"
        id="zone_2756"
        fill={getFill("zone_2756")}

        onClick={() => toggleZone("zone_2756")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,582.89844 h -100 v 100 h 100 z"
        id="zone_2755"
        fill={getFill("zone_2755")}

        onClick={() => toggleZone("zone_2755")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,582.89844 v 100 h 100 v -100 z"
        id="zone_2754"
        fill={getFill("zone_2754")}

        onClick={() => toggleZone("zone_2754")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,482.89844 h -100 v 100 h 100 z"
        id="zone_2753"
        fill={getFill("zone_2753")}

        onClick={() => toggleZone("zone_2753")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,482.89844 v 100 h 100 v -100 z"
        id="zone_2752"
        fill={getFill("zone_2752")}

        onClick={() => toggleZone("zone_2752")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,382.89844 h -100 v 100 h 100 z"
        id="zone_2751"
        fill={getFill("zone_2751")}

        onClick={() => toggleZone("zone_2751")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,382.89844 v 100 h 100 v -100 z"
        id="zone_2750"
        fill={getFill("zone_2750")}

        onClick={() => toggleZone("zone_2750")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,282.89844 h -100 v 100 h 100 z"
        id="zone_2749"
        fill={getFill("zone_2749")}

        onClick={() => toggleZone("zone_2749")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,282.89844 v 100 h 100 v -100 z"
        id="zone_2748"
        fill={getFill("zone_2748")}

        onClick={() => toggleZone("zone_2748")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,182.89844 h -100 v 100 h 100 z"
        id="zone_2747"
        fill={getFill("zone_2747")}

        onClick={() => toggleZone("zone_2747")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,182.89844 v 100 h 100 v -100 z"
        id="zone_2746"
        fill={getFill("zone_2746")}

        onClick={() => toggleZone("zone_2746")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 282.89844,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2745"
        fill={getFill("zone_2745")}

        onClick={() => toggleZone("zone_2745")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,82.898438 h -100 V 182.89844 h 100 z"
        id="zone_2744"
        fill={getFill("zone_2744")}

        onClick={() => toggleZone("zone_2744")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 382.89844,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2743"
        fill={getFill("zone_2743")}

        onClick={() => toggleZone("zone_2743")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 382.89844,82.898438 h -100 V 182.89844 h 100 z"
        id="zone_2742"
        fill={getFill("zone_2742")}

        onClick={() => toggleZone("zone_2742")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 482.89844,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2741"
        fill={getFill("zone_2741")}

        onClick={() => toggleZone("zone_2741")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,82.898438 h -100 V 182.89844 h 100 z"
        id="zone_2740"
        fill={getFill("zone_2740")}

        onClick={() => toggleZone("zone_2740")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 582.89844,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2739"
        fill={getFill("zone_2739")}

        onClick={() => toggleZone("zone_2739")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 582.89844,82.898438 h -100 V 182.89844 h 100 z"
        id="zone_2738"
        fill={getFill("zone_2738")}

        onClick={() => toggleZone("zone_2738")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 682.89844,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2737"
        fill={getFill("zone_2737")}

        onClick={() => toggleZone("zone_2737")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,82.898438 h -100 V 182.89844 h 100 z"
        id="zone_2736"
        fill={getFill("zone_2736")}

        onClick={() => toggleZone("zone_2736")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 782.89844,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2735"
        fill={getFill("zone_2735")}

        onClick={() => toggleZone("zone_2735")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,82.898438 h -100 V 182.89844 h 100 z"
        id="zone_2734"
        fill={getFill("zone_2734")}

        onClick={() => toggleZone("zone_2734")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 882.89844,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2733"
        fill={getFill("zone_2733")}

        onClick={() => toggleZone("zone_2733")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,82.898438 h -100 V 182.89844 h 100 z"
        id="zone_2732"
        fill={getFill("zone_2732")}

        onClick={() => toggleZone("zone_2732")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 982.89844,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2731"
        fill={getFill("zone_2731")}

        onClick={() => toggleZone("zone_2731")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,82.898438 h -100 V 182.89844 h 100 z"
        id="zone_2730"
        fill={getFill("zone_2730")}

        onClick={() => toggleZone("zone_2730")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 1082.8984,82.898438 V -9.6015625 H 982.89844 V 82.898438 Z"
        id="zone_2729"
        fill={getFill("zone_2729")}

        onClick={() => toggleZone("zone_2729")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 1082.8984,82.898438 H 982.89844 V 182.89844 h 99.99996 z"
        id="zone_2728"
        fill={getFill("zone_2728")}

        onClick={() => toggleZone("zone_2728")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 1182.8984,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2727"
        fill={getFill("zone_2727")}

        onClick={() => toggleZone("zone_2727")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,82.898438 h -100 V 182.89844 h 100 z"
        id="zone_2726"
        fill={getFill("zone_2726")}

        onClick={() => toggleZone("zone_2726")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 1282.8984,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2725"
        fill={getFill("zone_2725")}

        onClick={() => toggleZone("zone_2725")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1282.8984,82.898438 h -100 V 182.89844 h 100 z"
        id="zone_2724"
        fill={getFill("zone_2724")}

        onClick={() => toggleZone("zone_2724")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 1382.8984,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2723"
        fill={getFill("zone_2723")}

        onClick={() => toggleZone("zone_2723")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,82.898438 h -100 V 182.89844 h 100 z"
        id="zone_2722"
        fill={getFill("zone_2722")}

        onClick={() => toggleZone("zone_2722")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 1482.8984,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2721"
        fill={getFill("zone_2721")}

        onClick={() => toggleZone("zone_2721")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1482.8984,82.898438 h -100 V 182.89844 h 100 z"
        id="zone_2720"
        fill={getFill("zone_2720")}

        onClick={() => toggleZone("zone_2720")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,82.898438 h 100 V -9.6015625 h -100 z"
        id="zone_2719"
        fill={getFill("zone_2719")}

        onClick={() => toggleZone("zone_2719")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 1582.8984,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2718"
        fill={getFill("zone_2718")}

        onClick={() => toggleZone("zone_2718")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,182.89844 h 100 V 82.898438 h -100 z"
        id="zone_2717"
        fill={getFill("zone_2717")}

        onClick={() => toggleZone("zone_2717")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 1582.8984,182.89844 V 82.898438 h -100 V 182.89844 Z"
        id="zone_2716"
        fill={getFill("zone_2716")}

        onClick={() => toggleZone("zone_2716")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,282.89844 h 100 v -100 h -100 z"
        id="zone_2715"
        fill={getFill("zone_2715")}

        onClick={() => toggleZone("zone_2715")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,282.89844 v -100 h -100 v 100 z"
        id="zone_2714"
        fill={getFill("zone_2714")}

        onClick={() => toggleZone("zone_2714")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,382.89844 h 100 v -100 h -100 z"
        id="zone_2713"
        fill={getFill("zone_2713")}

        onClick={() => toggleZone("zone_2713")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,382.89844 v -100 h -100 v 100 z"
        id="zone_2712"
        fill={getFill("zone_2712")}

        onClick={() => toggleZone("zone_2712")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,482.89844 h 100 v -100 h -100 z"
        id="zone_2711"
        fill={getFill("zone_2711")}

        onClick={() => toggleZone("zone_2711")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,482.89844 v -100 h -100 v 100 z"
        id="zone_2710"
        fill={getFill("zone_2710")}

        onClick={() => toggleZone("zone_2710")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,582.89844 h 100 v -100 h -100 z"
        id="zone_2709"
        fill={getFill("zone_2709")}

        onClick={() => toggleZone("zone_2709")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,582.89844 v -100 h -100 v 100 z"
        id="zone_2708"
        fill={getFill("zone_2708")}

        onClick={() => toggleZone("zone_2708")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,682.89844 h 100 v -100 h -100 z"
        id="zone_2707"
        fill={getFill("zone_2707")}

        onClick={() => toggleZone("zone_2707")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,682.89844 v -100 h -100 v 100 z"
        id="zone_2706"
        fill={getFill("zone_2706")}

        onClick={() => toggleZone("zone_2706")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,782.89844 h 100 v -100 h -100 z"
        id="zone_2705"
        fill={getFill("zone_2705")}

        onClick={() => toggleZone("zone_2705")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,782.89844 v -100 h -100 v 100 z"
        id="zone_2704"
        fill={getFill("zone_2704")}

        onClick={() => toggleZone("zone_2704")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,882.89844 h 100 v -100 h -100 z"
        id="zone_2703"
        fill={getFill("zone_2703")}

        onClick={() => toggleZone("zone_2703")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,882.89844 v -100 h -100 v 100 z"
        id="zone_2702"
        fill={getFill("zone_2702")}

        onClick={() => toggleZone("zone_2702")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,982.89844 h 100 v -100 h -100 z"
        id="zone_2701"
        fill={getFill("zone_2701")}

        onClick={() => toggleZone("zone_2701")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,982.89844 v -100 h -100 v 100 z"
        id="zone_2700"
        fill={getFill("zone_2700")}

        onClick={() => toggleZone("zone_2700")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1082.8984 h 100 v -99.99996 h -100 z"
        id="zone_2699"
        fill={getFill("zone_2699")}

        onClick={() => toggleZone("zone_2699")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1082.8984 v -99.99996 h -100 v 99.99996 z"
        id="zone_2698"
        fill={getFill("zone_2698")}

        onClick={() => toggleZone("zone_2698")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1182.8984 h 100 v -100 h -100 z"
        id="zone_2697"
        fill={getFill("zone_2697")}

        onClick={() => toggleZone("zone_2697")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1182.8984 v -100 h -100 v 100 z"
        id="zone_2696"
        fill={getFill("zone_2696")}

        onClick={() => toggleZone("zone_2696")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1282.8984 h 100 v -100 h -100 z"
        id="zone_2695"
        fill={getFill("zone_2695")}

        onClick={() => toggleZone("zone_2695")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1282.8984 v -100 h -100 v 100 z"
        id="zone_2694"
        fill={getFill("zone_2694")}

        onClick={() => toggleZone("zone_2694")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1382.8984 h 100 v -100 h -100 z"
        id="zone_2693"
        fill={getFill("zone_2693")}

        onClick={() => toggleZone("zone_2693")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1382.8984 v -100 h -100 v 100 z"
        id="zone_2692"
        fill={getFill("zone_2692")}

        onClick={() => toggleZone("zone_2692")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1482.8984 h 100 v -100 h -100 z"
        id="zone_2691"
        fill={getFill("zone_2691")}

        onClick={() => toggleZone("zone_2691")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1482.8984 v -100 h -100 v 100 z"
        id="zone_2690"
        fill={getFill("zone_2690")}

        onClick={() => toggleZone("zone_2690")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1582.8984 h 100 v -100 h -100 z"
        id="zone_2689"
        fill={getFill("zone_2689")}

        onClick={() => toggleZone("zone_2689")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1582.8984 v -100 h -100 v 100 z"
        id="zone_2688"
        fill={getFill("zone_2688")}

        onClick={() => toggleZone("zone_2688")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1682.8984 h 100 v -100 h -100 z"
        id="zone_2687"
        fill={getFill("zone_2687")}

        onClick={() => toggleZone("zone_2687")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1682.8984 v -100 h -100 v 100 z"
        id="zone_2686"
        fill={getFill("zone_2686")}

        onClick={() => toggleZone("zone_2686")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1782.8984 h 100 v -100 h -100 z"
        id="zone_2685"
        fill={getFill("zone_2685")}

        onClick={() => toggleZone("zone_2685")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1782.8984 v -100 h -100 v 100 z"
        id="zone_2684"
        fill={getFill("zone_2684")}

        onClick={() => toggleZone("zone_2684")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1882.8984 h 100 v -100 h -100 z"
        id="zone_2683"
        fill={getFill("zone_2683")}

        onClick={() => toggleZone("zone_2683")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1882.8984 v -100 h -100 v 100 z"
        id="zone_2682"
        fill={getFill("zone_2682")}

        onClick={() => toggleZone("zone_2682")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1982.8984 h 100 v -100 h -100 z"
        id="zone_2681"
        fill={getFill("zone_2681")}

        onClick={() => toggleZone("zone_2681")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,1982.8984 v -100 h -100 v 100 z"
        id="zone_2680"
        fill={getFill("zone_2680")}

        onClick={() => toggleZone("zone_2680")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,2082.8984 h 100 v -100 h -100 z"
        id="zone_2679"
        fill={getFill("zone_2679")}

        onClick={() => toggleZone("zone_2679")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,2082.8984 v -100 h -100 v 100 z"
        id="zone_2678"
        fill={getFill("zone_2678")}

        onClick={() => toggleZone("zone_2678")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,2182.8984 h 100 v -100 h -100 z"
        id="zone_2677"
        fill={getFill("zone_2677")}

        onClick={() => toggleZone("zone_2677")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,2182.8984 v -100 h -100 v 100 z"
        id="zone_2676"
        fill={getFill("zone_2676")}

        onClick={() => toggleZone("zone_2676")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,2282.8984 h 100 v -100 h -100 z"
        id="zone_2675"
        fill={getFill("zone_2675")}

        onClick={() => toggleZone("zone_2675")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,2282.8984 v -100 h -100 v 100 z"
        id="zone_2674"
        fill={getFill("zone_2674")}

        onClick={() => toggleZone("zone_2674")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,2382.8984 v 100 h 100 v -100 z"
        id="zone_2673"
        fill={getFill("zone_2673")}

        onClick={() => toggleZone("zone_2673")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,2382.8984 h 100 v -100 h -100 z"
        id="zone_2672"
        fill={getFill("zone_2672")}

        onClick={() => toggleZone("zone_2672")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1482.8984,2382.8984 v 100 h 100 v -100 z"
        id="zone_2671"
        fill={getFill("zone_2671")}

        onClick={() => toggleZone("zone_2671")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1482.8984,2382.8984 h 100 v -100 h -100 z"
        id="zone_2670"
        fill={getFill("zone_2670")}

        onClick={() => toggleZone("zone_2670")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,2382.8984 v 100 h 100 v -100 z"
        id="zone_2669"
        fill={getFill("zone_2669")}

        onClick={() => toggleZone("zone_2669")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,2382.8984 h 100 v -100 h -100 z"
        id="zone_2668"
        fill={getFill("zone_2668")}

        onClick={() => toggleZone("zone_2668")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1282.8984,2382.8984 v 100 h 100 v -100 z"
        id="zone_2667"
        fill={getFill("zone_2667")}

        onClick={() => toggleZone("zone_2667")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1282.8984,2382.8984 h 100 v -100 h -100 z"
        id="zone_2666"
        fill={getFill("zone_2666")}

        onClick={() => toggleZone("zone_2666")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,2382.8984 v 100 h 100 v -100 z"
        id="zone_2665"
        fill={getFill("zone_2665")}

        onClick={() => toggleZone("zone_2665")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,2382.8984 h 100 v -100 h -100 z"
        id="zone_2664"
        fill={getFill("zone_2664")}

        onClick={() => toggleZone("zone_2664")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1082.8984,2382.8984 v 100 h 100 v -100 z"
        id="zone_2663"
        fill={getFill("zone_2663")}

        onClick={() => toggleZone("zone_2663")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1082.8984,2382.8984 h 100 v -100 h -100 z"
        id="zone_2662"
        fill={getFill("zone_2662")}

        onClick={() => toggleZone("zone_2662")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,2382.8984 v 100 h 99.99996 v -100 z"
        id="zone_2661"
        fill={getFill("zone_2661")}

        onClick={() => toggleZone("zone_2661")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,2382.8984 h 99.99996 v -100 h -99.99996 z"
        id="zone_2660"
        fill={getFill("zone_2660")}

        onClick={() => toggleZone("zone_2660")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,2382.8984 v 100 h 100 v -100 z"
        id="zone_2659"
        fill={getFill("zone_2659")}

        onClick={() => toggleZone("zone_2659")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,2382.8984 h 100 v -100 h -100 z"
        id="zone_2658"
        fill={getFill("zone_2658")}

        onClick={() => toggleZone("zone_2658")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,2382.8984 v 100 h 100 v -100 z"
        id="zone_2657"
        fill={getFill("zone_2657")}

        onClick={() => toggleZone("zone_2657")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,2382.8984 h 100 v -100 h -100 z"
        id="zone_2656"
        fill={getFill("zone_2656")}

        onClick={() => toggleZone("zone_2656")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,2382.8984 v 100 h 100 v -100 z"
        id="zone_2655"
        fill={getFill("zone_2655")}

        onClick={() => toggleZone("zone_2655")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,2382.8984 h 100 v -100 h -100 z"
        id="zone_2654"
        fill={getFill("zone_2654")}

        onClick={() => toggleZone("zone_2654")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 582.89844,2382.8984 v 100 h 100 v -100 z"
        id="zone_2653"
        fill={getFill("zone_2653")}

        onClick={() => toggleZone("zone_2653")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 582.89844,2382.8984 h 100 v -100 h -100 z"
        id="zone_2652"
        fill={getFill("zone_2652")}

        onClick={() => toggleZone("zone_2652")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,2382.8984 v 100 h 100 v -100 z"
        id="zone_2651"
        fill={getFill("zone_2651")}

        onClick={() => toggleZone("zone_2651")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,2382.8984 h 100 v -100 h -100 z"
        id="zone_2650"
        fill={getFill("zone_2650")}

        onClick={() => toggleZone("zone_2650")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 382.89844,2382.8984 v 100 h 100 v -100 z"
        id="zone_2649"
        fill={getFill("zone_2649")}

        onClick={() => toggleZone("zone_2649")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 382.89844,2382.8984 h 100 v -100 h -100 z"
        id="zone_2648"
        fill={getFill("zone_2648")}

        onClick={() => toggleZone("zone_2648")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,2382.8984 v 100 h 100 v -100 z"
        id="zone_2647"
        fill={getFill("zone_2647")}

        onClick={() => toggleZone("zone_2647")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,2382.8984 h 100 v -100 h -100 z"
        id="zone_2646"
        fill={getFill("zone_2646")}

        onClick={() => toggleZone("zone_2646")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 182.89844,2382.8984 v 100 h 100 v -100 z"
        id="zone_2645"
        fill={getFill("zone_2645")}

        onClick={() => toggleZone("zone_2645")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 182.89844,2382.8984 h 100 v -100 h -100 z"
        id="zone_2644"
        fill={getFill("zone_2644")}

        onClick={() => toggleZone("zone_2644")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,2382.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2643"
        fill={getFill("zone_2643")}

        onClick={() => toggleZone("zone_2643")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,2382.8984 v 100 H 182.89844 v -100 z"
        id="zone_2642"
        fill={getFill("zone_2642")}

        onClick={() => toggleZone("zone_2642")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,2282.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2641"
        fill={getFill("zone_2641")}

        onClick={() => toggleZone("zone_2641")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,2282.8984 v 100 H 182.89844 v -100 z"
        id="zone_2640"
        fill={getFill("zone_2640")}

        onClick={() => toggleZone("zone_2640")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,2182.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2639"
        fill={getFill("zone_2639")}

        onClick={() => toggleZone("zone_2639")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,2182.8984 v 100 H 182.89844 v -100 z"
        id="zone_2638"
        fill={getFill("zone_2638")}

        onClick={() => toggleZone("zone_2638")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,2082.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2637"
        fill={getFill("zone_2637")}

        onClick={() => toggleZone("zone_2637")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,2082.8984 v 100 H 182.89844 v -100 z"
        id="zone_2636"
        fill={getFill("zone_2636")}

        onClick={() => toggleZone("zone_2636")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,1982.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2635"
        fill={getFill("zone_2635")}

        onClick={() => toggleZone("zone_2635")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,1982.8984 v 100 H 182.89844 v -100 z"
        id="zone_2634"
        fill={getFill("zone_2634")}

        onClick={() => toggleZone("zone_2634")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,1882.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2633"
        fill={getFill("zone_2633")}

        onClick={() => toggleZone("zone_2633")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,1882.8984 v 100 H 182.89844 v -100 z"
        id="zone_2632"
        fill={getFill("zone_2632")}

        onClick={() => toggleZone("zone_2632")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,1782.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2631"
        fill={getFill("zone_2631")}

        onClick={() => toggleZone("zone_2631")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,1782.8984 v 100 H 182.89844 v -100 z"
        id="zone_2630"
        fill={getFill("zone_2630")}

        onClick={() => toggleZone("zone_2630")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,1682.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2629"
        fill={getFill("zone_2629")}

        onClick={() => toggleZone("zone_2629")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,1682.8984 v 100 H 182.89844 v -100 z"
        id="zone_2628"
        fill={getFill("zone_2628")}

        onClick={() => toggleZone("zone_2628")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,1582.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2627"
        fill={getFill("zone_2627")}

        onClick={() => toggleZone("zone_2627")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,1582.8984 v 100 H 182.89844 v -100 z"
        id="zone_2626"
        fill={getFill("zone_2626")}

        onClick={() => toggleZone("zone_2626")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,1482.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2625"
        fill={getFill("zone_2625")}

        onClick={() => toggleZone("zone_2625")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,1482.8984 v 100 H 182.89844 v -100 z"
        id="zone_2624"
        fill={getFill("zone_2624")}

        onClick={() => toggleZone("zone_2624")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,1382.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2623"
        fill={getFill("zone_2623")}

        onClick={() => toggleZone("zone_2623")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,1382.8984 v 100 H 182.89844 v -100 z"
        id="zone_2622"
        fill={getFill("zone_2622")}

        onClick={() => toggleZone("zone_2622")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,1282.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2621"
        fill={getFill("zone_2621")}

        onClick={() => toggleZone("zone_2621")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,1282.8984 v 100 H 182.89844 v -100 z"
        id="zone_2620"
        fill={getFill("zone_2620")}

        onClick={() => toggleZone("zone_2620")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,1182.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2619"
        fill={getFill("zone_2619")}

        onClick={() => toggleZone("zone_2619")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,1182.8984 v 100 H 182.89844 v -100 z"
        id="zone_2618"
        fill={getFill("zone_2618")}

        onClick={() => toggleZone("zone_2618")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,1082.8984 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2617"
        fill={getFill("zone_2617")}

        onClick={() => toggleZone("zone_2617")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,1082.8984 v 100 H 182.89844 v -100 z"
        id="zone_2616"
        fill={getFill("zone_2616")}

        onClick={() => toggleZone("zone_2616")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,982.89844 H -9.6015625 v 99.99996 H 82.898438 Z"
        id="zone_2615"
        fill={getFill("zone_2615")}

        onClick={() => toggleZone("zone_2615")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,982.89844 v 99.99996 H 182.89844 v -99.99996 z"
        id="zone_2614"
        fill={getFill("zone_2614")}

        onClick={() => toggleZone("zone_2614")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,882.89844 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2613"
        fill={getFill("zone_2613")}

        onClick={() => toggleZone("zone_2613")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,882.89844 v 100 H 182.89844 v -100 z"
        id="zone_2612"
        fill={getFill("zone_2612")}

        onClick={() => toggleZone("zone_2612")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,782.89844 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2611"
        fill={getFill("zone_2611")}

        onClick={() => toggleZone("zone_2611")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,782.89844 v 100 H 182.89844 v -100 z"
        id="zone_2610"
        fill={getFill("zone_2610")}

        onClick={() => toggleZone("zone_2610")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,682.89844 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2609"
        fill={getFill("zone_2609")}

        onClick={() => toggleZone("zone_2609")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,682.89844 v 100 H 182.89844 v -100 z"
        id="zone_2608"
        fill={getFill("zone_2608")}

        onClick={() => toggleZone("zone_2608")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,582.89844 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2607"
        fill={getFill("zone_2607")}

        onClick={() => toggleZone("zone_2607")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,582.89844 v 100 H 182.89844 v -100 z"
        id="zone_2606"
        fill={getFill("zone_2606")}

        onClick={() => toggleZone("zone_2606")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,482.89844 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2605"
        fill={getFill("zone_2605")}

        onClick={() => toggleZone("zone_2605")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,482.89844 v 100 H 182.89844 v -100 z"
        id="zone_2604"
        fill={getFill("zone_2604")}

        onClick={() => toggleZone("zone_2604")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,382.89844 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2603"
        fill={getFill("zone_2603")}

        onClick={() => toggleZone("zone_2603")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,382.89844 v 100 H 182.89844 v -100 z"
        id="zone_2602"
        fill={getFill("zone_2602")}

        onClick={() => toggleZone("zone_2602")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,282.89844 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2601"
        fill={getFill("zone_2601")}

        onClick={() => toggleZone("zone_2601")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,282.89844 v 100 H 182.89844 v -100 z"
        id="zone_2600"
        fill={getFill("zone_2600")}

        onClick={() => toggleZone("zone_2600")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,182.89844 H -9.6015625 v 100 H 82.898438 Z"
        id="zone_2599"
        fill={getFill("zone_2599")}

        onClick={() => toggleZone("zone_2599")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,182.89844 v 100 H 182.89844 v -100 z"
        id="zone_2598"
        fill={getFill("zone_2598")}

        onClick={() => toggleZone("zone_2598")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,82.898438 H -9.6015625 V 182.89844 H 82.898438 Z"
        id="zone_2597"
        fill={getFill("zone_2597")}

        onClick={() => toggleZone("zone_2597")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,82.898438 V 182.89844 H 182.89844 V 82.898438 Z"
        id="zone_2596"
        fill={getFill("zone_2596")}

        onClick={() => toggleZone("zone_2596")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,-9.6015625 H 3.3769531 c -7.1900807,0 -12.9785156,5.7884349 -12.9785156,12.9785156 V 82.898438 H 82.898438 Z"
        id="zone_2595"
        fill={getFill("zone_2595")}

        onClick={() => toggleZone("zone_2595")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,-9.6015625 V 82.898438 H 182.89844 V -9.6015625 Z"
        id="zone_2594"
        fill={getFill("zone_2594")}

        onClick={() => toggleZone("zone_2594")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,82.898438 h 70.3848 V 3.3769531 c 0,-7.1900807 -5.7884,-12.9785156 -12.9785,-12.9785156 h -57.4063 z"
        id="zone_2593"
        fill={getFill("zone_2593")}

        onClick={() => toggleZone("zone_2593")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 1782.8984,82.898438 V -9.6015625 h -100 V 82.898438 Z"
        id="zone_2592"
        fill={getFill("zone_2592")}

        onClick={() => toggleZone("zone_2592")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,182.89844 h 70.3848 V 82.898438 h -70.3848 z"
        id="zone_2591"
        fill={getFill("zone_2591")}

        onClick={() => toggleZone("zone_2591")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 1782.8984,182.89844 V 82.898438 h -100 V 182.89844 Z"
        id="zone_2590"
        fill={getFill("zone_2590")}

        onClick={() => toggleZone("zone_2590")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,282.89844 h 70.3848 v -100 h -70.3848 z"
        id="zone_2589"
        fill={getFill("zone_2589")}

        onClick={() => toggleZone("zone_2589")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,282.89844 v -100 h -100 v 100 z"
        id="zone_2588"
        fill={getFill("zone_2588")}

        onClick={() => toggleZone("zone_2588")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,382.89844 h 70.3848 v -100 h -70.3848 z"
        id="zone_2587"
        fill={getFill("zone_2587")}

        onClick={() => toggleZone("zone_2587")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,382.89844 v -100 h -100 v 100 z"
        id="zone_2586"
        fill={getFill("zone_2586")}

        onClick={() => toggleZone("zone_2586")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,482.89844 h 70.3848 v -100 h -70.3848 z"
        id="zone_2585"
        fill={getFill("zone_2585")}

        onClick={() => toggleZone("zone_2585")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,482.89844 v -100 h -100 v 100 z"
        id="zone_2584"
        fill={getFill("zone_2584")}

        onClick={() => toggleZone("zone_2584")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,582.89844 h 70.3848 v -100 h -70.3848 z"
        id="zone_2583"
        fill={getFill("zone_2583")}

        onClick={() => toggleZone("zone_2583")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,582.89844 v -100 h -100 v 100 z"
        id="zone_2582"
        fill={getFill("zone_2582")}

        onClick={() => toggleZone("zone_2582")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,682.89844 h 70.3848 v -100 h -70.3848 z"
        id="zone_2581"
        fill={getFill("zone_2581")}

        onClick={() => toggleZone("zone_2581")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,682.89844 v -100 h -100 v 100 z"
        id="zone_2580"
        fill={getFill("zone_2580")}

        onClick={() => toggleZone("zone_2580")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,782.89844 h 70.3848 v -100 h -70.3848 z"
        id="zone_2579"
        fill={getFill("zone_2579")}

        onClick={() => toggleZone("zone_2579")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,782.89844 v -100 h -100 v 100 z"
        id="zone_2578"
        fill={getFill("zone_2578")}

        onClick={() => toggleZone("zone_2578")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,882.89844 h 70.3848 v -100 h -70.3848 z"
        id="zone_2577"
        fill={getFill("zone_2577")}

        onClick={() => toggleZone("zone_2577")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,882.89844 v -100 h -100 v 100 z"
        id="zone_2576"
        fill={getFill("zone_2576")}

        onClick={() => toggleZone("zone_2576")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,982.89844 h 70.3848 v -100 h -70.3848 z"
        id="zone_2575"
        fill={getFill("zone_2575")}

        onClick={() => toggleZone("zone_2575")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,982.89844 v -100 h -100 v 100 z"
        id="zone_2574"
        fill={getFill("zone_2574")}

        onClick={() => toggleZone("zone_2574")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1082.8984 h 70.3848 v -99.99996 h -70.3848 z"
        id="zone_2573"
        fill={getFill("zone_2573")}

        onClick={() => toggleZone("zone_2573")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1082.8984 v -99.99996 h -100 v 99.99996 z"
        id="zone_2572"
        fill={getFill("zone_2572")}

        onClick={() => toggleZone("zone_2572")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1182.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2571"
        fill={getFill("zone_2571")}

        onClick={() => toggleZone("zone_2571")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1182.8984 v -100 h -100 v 100 z"
        id="zone_2570"
        fill={getFill("zone_2570")}

        onClick={() => toggleZone("zone_2570")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1282.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2569"
        fill={getFill("zone_2569")}

        onClick={() => toggleZone("zone_2569")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1282.8984 v -100 h -100 v 100 z"
        id="zone_2568"
        fill={getFill("zone_2568")}

        onClick={() => toggleZone("zone_2568")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1382.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2567"
        fill={getFill("zone_2567")}

        onClick={() => toggleZone("zone_2567")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1382.8984 v -100 h -100 v 100 z"
        id="zone_2566"
        fill={getFill("zone_2566")}

        onClick={() => toggleZone("zone_2566")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1482.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2565"
        fill={getFill("zone_2565")}

        onClick={() => toggleZone("zone_2565")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1482.8984 v -100 h -100 v 100 z"
        id="zone_2564"
        fill={getFill("zone_2564")}

        onClick={() => toggleZone("zone_2564")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1582.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2563"
        fill={getFill("zone_2563")}

        onClick={() => toggleZone("zone_2563")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1582.8984 v -100 h -100 v 100 z"
        id="zone_2562"
        fill={getFill("zone_2562")}

        onClick={() => toggleZone("zone_2562")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1682.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2561"
        fill={getFill("zone_2561")}

        onClick={() => toggleZone("zone_2561")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1682.8984 v -100 h -100 v 100 z"
        id="zone_2560"
        fill={getFill("zone_2560")}

        onClick={() => toggleZone("zone_2560")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1782.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2559"
        fill={getFill("zone_2559")}

        onClick={() => toggleZone("zone_2559")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1782.8984 v -100 h -100 v 100 z"
        id="zone_2558"
        fill={getFill("zone_2558")}

        onClick={() => toggleZone("zone_2558")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1882.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2557"
        fill={getFill("zone_2557")}

        onClick={() => toggleZone("zone_2557")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1882.8984 v -100 h -100 v 100 z"
        id="zone_2556"
        fill={getFill("zone_2556")}

        onClick={() => toggleZone("zone_2556")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1982.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2555"
        fill={getFill("zone_2555")}

        onClick={() => toggleZone("zone_2555")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,1982.8984 v -100 h -100 v 100 z"
        id="zone_2554"
        fill={getFill("zone_2554")}

        onClick={() => toggleZone("zone_2554")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,2082.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2553"
        fill={getFill("zone_2553")}

        onClick={() => toggleZone("zone_2553")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,2082.8984 v -100 h -100 v 100 z"
        id="zone_2552"
        fill={getFill("zone_2552")}

        onClick={() => toggleZone("zone_2552")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,2182.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2551"
        fill={getFill("zone_2551")}

        onClick={() => toggleZone("zone_2551")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,2182.8984 v -100 h -100 v 100 z"
        id="zone_2550"
        fill={getFill("zone_2550")}

        onClick={() => toggleZone("zone_2550")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,2282.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2549"
        fill={getFill("zone_2549")}

        onClick={() => toggleZone("zone_2549")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,2282.8984 v -100 h -100 v 100 z"
        id="zone_2548"
        fill={getFill("zone_2548")}

        onClick={() => toggleZone("zone_2548")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,2382.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2547"
        fill={getFill("zone_2547")}

        onClick={() => toggleZone("zone_2547")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,2382.8984 v -100 h -100 v 100 z"
        id="zone_2546"
        fill={getFill("zone_2546")}

        onClick={() => toggleZone("zone_2546")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,2482.8984 h 70.3848 v -100 h -70.3848 z"
        id="zone_2545"
        fill={getFill("zone_2545")}

        onClick={() => toggleZone("zone_2545")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,2482.8984 v -100 h -100 v 100 z"
        id="zone_2544"
        fill={getFill("zone_2544")}

        onClick={() => toggleZone("zone_2544")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,2582.8984 v 9.7754 h 57.4063 c 6.0845,0 11.1634,-4.1434 12.582,-9.7754 z"
        id="zone_2543"
        fill={getFill("zone_2543")}

        onClick={() => toggleZone("zone_2543")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1782.8984,2582.8984 h 69.9883 c 0.2578,-1.0233 0.3965,-2.0975 0.3965,-3.2031 v -96.7969 h -70.3848 z"
        id="zone_2542"
        fill={getFill("zone_2542")}

        onClick={() => toggleZone("zone_2542")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1682.8984,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2541"
        fill={getFill("zone_2541")}

        onClick={() => toggleZone("zone_2541")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1682.8984,2582.8984 h 100 v -100 h -100 z"
        id="zone_2540"
        fill={getFill("zone_2540")}

        onClick={() => toggleZone("zone_2540")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2539"
        fill={getFill("zone_2539")}

        onClick={() => toggleZone("zone_2539")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1582.8984,2582.8984 h 100 v -100 h -100 z"
        id="zone_2538"
        fill={getFill("zone_2538")}

        onClick={() => toggleZone("zone_2538")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1482.8984,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2537"
        fill={getFill("zone_2537")}

        onClick={() => toggleZone("zone_2537")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1482.8984,2582.8984 h 100 v -100 h -100 z"
        id="zone_2536"
        fill={getFill("zone_2536")}

        onClick={() => toggleZone("zone_2536")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2535"
        fill={getFill("zone_2535")}

        onClick={() => toggleZone("zone_2535")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1382.8984,2582.8984 h 100 v -100 h -100 z"
        id="zone_2534"
        fill={getFill("zone_2534")}

        onClick={() => toggleZone("zone_2534")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1282.8984,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2533"
        fill={getFill("zone_2533")}

        onClick={() => toggleZone("zone_2533")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1282.8984,2582.8984 h 100 v -100 h -100 z"
        id="zone_2532"
        fill={getFill("zone_2532")}

        onClick={() => toggleZone("zone_2532")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2531"
        fill={getFill("zone_2531")}

        onClick={() => toggleZone("zone_2531")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1182.8984,2582.8984 h 100 v -100 h -100 z"
        id="zone_2530"
        fill={getFill("zone_2530")}

        onClick={() => toggleZone("zone_2530")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1082.8984,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2529"
        fill={getFill("zone_2529")}

        onClick={() => toggleZone("zone_2529")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 1082.8984,2582.8984 h 100 v -100 h -100 z"
        id="zone_2528"
        fill={getFill("zone_2528")}

        onClick={() => toggleZone("zone_2528")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,2582.8984 v 9.7754 h 99.99996 v -9.7754 z"
        id="zone_2527"
        fill={getFill("zone_2527")}

        onClick={() => toggleZone("zone_2527")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 982.89844,2582.8984 h 99.99996 v -100 h -99.99996 z"
        id="zone_2526"
        fill={getFill("zone_2526")}

        onClick={() => toggleZone("zone_2526")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2525"
        fill={getFill("zone_2525")}

        onClick={() => toggleZone("zone_2525")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 882.89844,2582.8984 h 100 v -100 h -100 z"
        id="zone_2524"
        fill={getFill("zone_2524")}

        onClick={() => toggleZone("zone_2524")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2523"
        fill={getFill("zone_2523")}

        onClick={() => toggleZone("zone_2523")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 782.89844,2582.8984 h 100 v -100 h -100 z"
        id="zone_2522"
        fill={getFill("zone_2522")}

        onClick={() => toggleZone("zone_2522")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2521"
        fill={getFill("zone_2521")}

        onClick={() => toggleZone("zone_2521")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 682.89844,2582.8984 h 100 v -100 h -100 z"
        id="zone_2520"
        fill={getFill("zone_2520")}

        onClick={() => toggleZone("zone_2520")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 582.89844,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2519"
        fill={getFill("zone_2519")}

        onClick={() => toggleZone("zone_2519")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 582.89844,2582.8984 h 100 v -100 h -100 z"
        id="zone_2518"
        fill={getFill("zone_2518")}

        onClick={() => toggleZone("zone_2518")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2517"
        fill={getFill("zone_2517")}

        onClick={() => toggleZone("zone_2517")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 482.89844,2582.8984 h 100 v -100 h -100 z"
        id="zone_2516"
        fill={getFill("zone_2516")}

        onClick={() => toggleZone("zone_2516")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 382.89844,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2515"
        fill={getFill("zone_2515")}

        onClick={() => toggleZone("zone_2515")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 382.89844,2582.8984 h 100 v -100 h -100 z"
        id="zone_2514"
        fill={getFill("zone_2514")}

        onClick={() => toggleZone("zone_2514")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2513"
        fill={getFill("zone_2513")}

        onClick={() => toggleZone("zone_2513")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 282.89844,2582.8984 h 100 v -100 h -100 z"
        id="zone_2512"
        fill={getFill("zone_2512")}

        onClick={() => toggleZone("zone_2512")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 182.89844,2582.8984 v 9.7754 h 100 v -9.7754 z"
        id="zone_2511"
        fill={getFill("zone_2511")}

        onClick={() => toggleZone("zone_2511")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 182.89844,2582.8984 h 100 v -100 h -100 z"
        id="zone_2510"
        fill={getFill("zone_2510")}

        onClick={() => toggleZone("zone_2510")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m 82.898438,2582.8984 v 9.7754 H 182.89844 v -9.7754 z"
        id="zone_2509"
        fill={getFill("zone_2509")}

        onClick={() => toggleZone("zone_2509")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M 82.898438,2582.8984 H 182.89844 v -100 H 82.898438 Z"
        id="zone_2508"
        fill={getFill("zone_2508")}

        onClick={() => toggleZone("zone_2508")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="m -9.2070312,2582.8984 c 1.4186219,5.632 6.4994888,9.7754 12.5839843,9.7754 H 82.898438 v -9.7754 z"
        id="zone_2507"
        fill={getFill("zone_2507")}

        onClick={() => toggleZone("zone_2507")} />
    <path
        stroke="#000"
        strokeWidth="6"
        opacity="1"
        d="M -9.2070312,2582.8984 H 82.898438 v -100 H -9.6015625 v 96.7969 c 0,1.1056 0.1367601,2.1798 0.3945313,3.2031 z"
        id="zone_2506"
        fill={getFill("zone_2506")}

        onClick={() => toggleZone("zone_2506")} />
    </svg>
    )
}

